import { Platform, StyleSheet } from 'react-native';

import {
  coral,
  neutralDark,
  neutralLight,
  neutralWhite,
  warrior,
  white,
} from '../../constants/color';

const styles: any = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: white,
    position: 'relative',
  },
  containerWrapper: {
    flex: 1,
    backgroundColor: neutralWhite,
  },
  eventField: {
    backgroundColor: neutralWhite,
    paddingBottom: Platform.OS === 'android' ? 0 : 10,
  },
  cartContentSection: {
    flex: 1,
    paddingHorizontal: 15,
    backgroundColor: white,
  },
  emptyWrapper: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  emptyText: {
    marginTop: 10,
    textAlign: 'center',
    fontSize: 12,
    color: neutralDark,
  },
  contentCard: {
    flex: 1,
    marginVertical: 10,
    minHeight: 100,
    backgroundColor: white,
    flexDirection: 'row',
  },
  separator: {
    flex: 1,
    maxHeight: 1,
    minHeight: 1,
    marginBottom: 0,
    padding: 0,
    borderStyle: 'solid',
    borderTopWidth: 1,
    borderColor: neutralLight,
  },
  selectionField: {
    width: 30,
    padding: 0,
  },
  imageField: {
    flex: 1,
    paddingRight: 10,
  },
  itemImage: {
    borderRadius: 3,
    minHeight: 80,
    maxHeight: 80,
    minWidth: 80,
    maxWidth: 80,
  },
  cancelButton: {
    position: 'absolute',
    right: 0,
    top: 0,
    width: 25,
    height: 25,
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
    zIndex: 1,
  },
  detailField: {
    position: 'relative',
    flex: 3,
  },
  descriptionField: {
    flex: 1,
    maxWidth: '90%',
  },
  titleField: {
    // flex: 1 will cause bug
  },
  titleText: {
    fontSize: 15,
    lineHeight: 20,
    color: warrior,
  },
  SKUField: {
    flex: 1,
    flexDirection: 'row',
  },
  SKUText: {
    fontSize: 12,
    lineHeight: 20,
    marginRight: 2,
    color: neutralDark,
  },
  paymentField: {
    flexDirection: 'row',
    minHeight: 30,
    maxHeight: 30,
  },
  priceField: {
    flex: 2,
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
  },
  priceText: {
    fontSize: 12,
    lineHeight: 17,
    color: coral,
  },
  counterField: {
    flex: 3,
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
  },
  // copy paste patw counter
  counter: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  counterDisplay: {
    color: warrior,
    fontSize: 15,
    lineHeight: 21,
    marginHorizontal: 16,
  },
  counterHandler: {
    width: 30,
    height: 30,
    borderRadius: 3,
    borderColor: neutralDark,
    borderWidth: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  dialogContainer: {
    width: 315,
    height: 200,
    borderRadius: 10,
    backgroundColor: white,
    justifyContent: 'space-between',
  },
  dialogContent: {
    alignItems: 'center',
    paddingVertical: 30,
    flex: 1,
  },
  dialogThumbnail: {
    width: 60,
    height: 60,
    marginBottom: 20,
  },
  dialogConfirmText: {
    fontSize: 15,
    color: warrior,
    fontWeight: 'normal',
  },
  dialogButton: {
    flex: 1,
    alignContent: 'center',
    justifyContent: 'center',
    height: 50,
    borderTopColor: neutralLight,
    borderTopWidth: 1,
  },
  dialogCancelButtonText: {
    fontSize: 15,
    color: warrior,
    textAlign: 'center',
    fontWeight: 'normal',
  },
  dialogConfirmButtonText: {
    fontSize: 15,
    color: coral,
    textAlign: 'center',
    fontWeight: 'normal',
  },
  bottomView: {
    justifyContent: 'flex-end',
  },
});

export default styles;
